import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { FileUp, FileText, ClipboardCheck, Hammer, Truck } from "lucide-react";
const steps = [{
  id: "1",
  title: "Spec or upload",
  description: "File formats DXF, DWG, AI, PDF, STEP, SVG; or part list; material recommendation offered if unsure.",
  icon: FileUp
}, {
  id: "2",
  title: "Quote",
  description: "Material, color, mounting, quantity pricing, real lead time, rush options.",
  icon: FileText
}, {
  id: "3",
  title: "Proof",
  description: "Written proof approval before anything is engraved; layout, text, dimensions confirmed.",
  icon: ClipboardCheck
}, {
  id: "4",
  title: "Production",
  description: "Production engraving equipment, specified material, in-process inspection.",
  icon: Hammer
}, {
  id: "5",
  title: "Ship",
  description: "Documentation included when specified (material data sheets, submittal records).",
  icon: Truck
}];
export default function HowItWorks() {
  return <section id="how-it-works" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-6">
            How Does Ordering Engraving Work?
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Every Evermark Industrial Solutions engraving job follows the same five-step path: spec, quote, proof, production, ship — whether it's one legend plate or a recurring OEM program.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-10 lg:gap-6 mb-16">
          {steps.map((step, i) => <div key={step.id} data-index={i} className="relative flex flex-col">
              {i < steps.length - 1 && <div className="hidden lg:block absolute top-6 left-[3.5rem] w-[calc(100%-2.5rem)] h-px bg-border" aria-hidden="true" />}
              
              <div className="flex flex-col gap-4 mb-5">
                <step.icon className="size-8 text-primary" strokeWidth={1.5} />
                <div className="text-5xl font-default font-bold text-primary/40">
                  0{step.id}
                </div>
              </div>
              
              <h3 className="font-default text-xl font-semibold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {step.description}
              </p>
            </div>)}
        </div>

        <div className="flex justify-center">
          <Button asChild size="lg" className="font-default font-semibold px-8">
            <Link to="/contact/">Start a Quote</Link>
          </Button>
        </div>
      </div>
    </section>;
}